<template>
  <teleport to="body">
    <transition name="fade">
      <div v-if="visible" class="preview-mask" @click.self="close">
        <div class="preview-container">
          <button class="close-btn" @click="close">×</button>

          <img
            v-if="isImage"
            :src="currentSrc"
            class="preview-media"
            alt="preview"
          />
          <video v-else class="preview-media" controls autoplay>
            <source :src="currentSrc" />
          </video>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'

export default {
  name: 'PreviewDialog',
  setup(_, { expose }) {
    const visible = ref(false)
    const currentSrc = ref('')
    const isImage = ref(true)

    function show(src) {
      currentSrc.value = src
      isImage.value = /\.(jpg|jpeg|png|gif|webp|bmp)$/i.test(src)
      visible.value = true
    }

    function close() {
      visible.value = false
    }

    function handleKey(e) {
      if (e.key === 'Escape') close()
    }

    onMounted(() => window.addEventListener('keydown', handleKey))
    onUnmounted(() => window.removeEventListener('keydown', handleKey))

    expose({ show, close }) // ✅ 暴露给外部实例调用

    return { visible, currentSrc, isImage, close }
  },
}
</script>

<style scoped>
.preview-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}
.preview-container {
  position: relative;
  max-width: 90%;
  max-height: 90%;
}
.preview-media {
  max-width: 100%;
  max-height: 100%;
  border-radius: 10px;
}
.close-btn {
  position: fixed;
  top: 5%;
  right: 10%;
  font-size: 36px;
  color: #fff;
  border: none;
  background: transparent;
  cursor: pointer;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
